//@ts-ignore
import ReCAPTCHA from "react-google-recaptcha";
import { styled } from "@mui/material";

export const RecaptchContainer = styled("div")({
  height: "100px",
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  padding: 0,
});

export const StyledReCAPTCHA = styled(ReCAPTCHA)({
  "& div": {
    "& div": {
      "& div": {
        "& iframe": {
          transform: "scale(0.9)",
        },
      },
    },
  },
});
